import { __read, __spreadArray } from 'tslib';
import { useState } from 'react';

/**
 * useTableSortable
 * helper functions for sorting single page table. Please createyour own hook / state management for multiple page
 */
var useTableSortable = function (_a) {
    var _b = _a === void 0 ? {} : _a, defaultSortedColumn = _b.defaultSortedColumn;
    var _c = __read(useState(defaultSortedColumn || {}), 2), sortedColumn = _c[0], setSortedColumn = _c[1];
    // `true` is asc, `false` is desc, `undefined` is no sorting
    var isSorted = function (id) { return sortedColumn[id]; };
    var getOrder = function (id) {
        var order = isSorted(id);
        if (order === undefined)
            return undefined;
        return order ? "asc" : "desc";
    };
    var sortColumn = function (id, state) {
        var _a;
        setSortedColumn((_a = {},
            _a[id] = state === undefined ? !isSorted(id) : state,
            _a));
    };
    var sortData = function (data) {
        if (!sortedColumn)
            return __spreadArray([], __read(data), false);
        var sortedColumnKey = Object.keys(sortedColumn)[0];
        return __spreadArray([], __read(data), false).sort(function (a, b) {
            var x = a[sortedColumnKey];
            var y = b[sortedColumnKey];
            if (sortedColumn[sortedColumnKey])
                return x > y ? 1 : -1;
            if (!sortedColumn[sortedColumnKey])
                return x < y ? 1 : -1;
            return 0;
        });
    };
    return {
        sortedColumn: sortedColumn,
        getOrder: getOrder,
        setSortedColumn: setSortedColumn,
        sortColumn: sortColumn,
        sortData: sortData,
    };
};

export { useTableSortable };
//# sourceMappingURL=useTableSortable.js.map
